<template>
  <div>
    <formInput
      v-bind:idEdit="this.$route.query ? this.$route.query.id : ''"
    />
  </div>
</template>
<script>
import formInput from '@/views/pages/user/form/Form.vue';

export default ({
  components: {
    formInput
  }
});
</script>
<style lang="scss" scoped>

</style>
